import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import { LoginContext } from '../../reactcontext/ReactContext';

const VisaExpire = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { loginInfo } = useContext(LoginContext);
  const [expiringVisas, setExpiringVisas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState({ value: '30', label: '30 Days' });

  const periods = [
    { value: '30', label: '30 Days' },
    { value: '60', label: '60 Days' },
    { value: '90', label: '90 Days' },
  ];

  useEffect(() => {
    if (!loginInfo.login) return;
    fetchExpiringVisas();
  }, [loginInfo, selectedPeriod]);

  const fetchExpiringVisas = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/employee/visaExpire/${selectedPeriod.value}`, {
        headers: { loginToken: localStorage.getItem('loginToken') },
      });
      setExpiringVisas(res.data.visas || []);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleRecordPayment = (employeeId) => {
    // Navigate to Record Payment with pre-selected employee
    // For simplicity, alert
    alert(`Record payment for employee ${employeeId}`);
  };

  return (
    <div className='w-full bg-gray-50 flex h-full flex-col items-center justify-between relative gap-3'>
      <div className='self-start ml-10 mt-10'>
        <Link to={'/payments'} className='text-yellow-700'>Payments</Link> {' > '} Visa Expire
      </div>

      <div className='w-full p-4 flex flex-col items-center justify-center gap-4'>
        <h1 className='text-xl font-semibold'>Visa Expiration Payments</h1>

        <div className='mb-4'>
          <label className='block text-sm font-medium'>Select Expiry Period</label>
          <Select
            options={periods}
            value={selectedPeriod}
            onChange={setSelectedPeriod}
            className='w-48'
          />
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className='w-full max-w-4xl'>
            <table className='w-full bg-white shadow rounded'>
              <thead>
                <tr className='bg-gray-200'>
                  <th className='p-2'>Employee Name</th>
                  <th className='p-2'>Passport Number</th>
                  <th className='p-2'>Visa Expiry</th>
                  <th className='p-2'>Agent</th>
                  <th className='p-2'>Balance</th>
                  <th className='p-2'>Actions</th>
                </tr>
              </thead>
              <tbody>
                {expiringVisas.map((visa, index) => (
                  <tr key={index} className='border-t'>
                    <td className='p-2'>{visa.Employee?.firstName} {visa.Employee?.lastName}</td>
                    <td className='p-2'>{visa.Employee?.idNo}</td>
                    <td className='p-2'>{visa.expiryDate}</td>
                    <td className='p-2'>{visa.Employee?.Agent?.name}</td>
                    <td className='p-2'>RM {visa.balance || 0}</td>
                    <td className='p-2'>
                      <button
                        onClick={() => handleRecordPayment(visa.Employee?.id)}
                        className='bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600'
                      >
                        Record Payment
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VisaExpire;